/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateMuscleTag
 */
export interface CreateMuscleTag {
    /**
     * 
     * @type {string}
     * @memberof CreateMuscleTag
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMuscleTag
     */
    imageId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMuscleTag
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMuscleTag
     */
    exemplaryExerciseId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateMuscleTag
     */
    connectedBoneIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateMuscleTag
     */
    groupMuscleTagIds?: Array<string>;
}

/**
 * Check if a given object implements the CreateMuscleTag interface.
 */
export function instanceOfCreateMuscleTag(value: object): value is CreateMuscleTag {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateMuscleTagFromJSON(json: any): CreateMuscleTag {
    return CreateMuscleTagFromJSONTyped(json, false);
}

export function CreateMuscleTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMuscleTag {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'description': json['description'] == null ? undefined : json['description'],
        'exemplaryExerciseId': json['exemplaryExerciseId'] == null ? undefined : json['exemplaryExerciseId'],
        'connectedBoneIds': json['connectedBoneIds'] == null ? undefined : json['connectedBoneIds'],
        'groupMuscleTagIds': json['groupMuscleTagIds'] == null ? undefined : json['groupMuscleTagIds'],
    };
}

export function CreateMuscleTagToJSON(json: any): CreateMuscleTag {
    return CreateMuscleTagToJSONTyped(json, false);
}

export function CreateMuscleTagToJSONTyped(value?: CreateMuscleTag | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'imageId': value['imageId'],
        'description': value['description'],
        'exemplaryExerciseId': value['exemplaryExerciseId'],
        'connectedBoneIds': value['connectedBoneIds'],
        'groupMuscleTagIds': value['groupMuscleTagIds'],
    };
}

